// HKDSE Mathematics Mock Data
// 香港中學文憑考試 數學科 模擬數據

export const hkdseMathsExams = [
  // Paper 1: 代數與函數 (Algebra & Functions)
  {
    id: 16,
    name: 'HKDSE Mathematics - Paper 1 (代數與函數)',
    nameEn: 'HKDSE Mathematics - Paper 1 (Algebra & Functions)',
    nameCn: 'HKDSE 数学 - 试卷1 (代数与函数)',
    nameJa: 'HKDSE 数学 - 試験1 (代数と関数)',
    course: '香港中學文憑考試',
    duration: 135,
    totalQuestions: 30,
    passingScore: 50,
    category: 'mathematics',
    difficulty: 'advanced',
    description: '測試代數運算、函數、方程式和不等式知識',
    modes: {
      examMode: {
        name: '考試模式',
        description: '正式考試環境，限時完成，無提示',
        timeLimit: 135,
        showAnswers: false,
        allowReview: false,
        saveProgress: true
      },
      studyMode: {
        name: '自習模式',
        description: '學習環境，即時查看答案和解釋',
        timeLimit: null,
        showAnswers: true,
        allowReview: true,
        saveProgress: true
      },
      preTestMode: {
        name: '預測模式',
        description: '模擬考試環境，完成後顯示結果',
        timeLimit: 135,
        showAnswers: false,
        allowReview: true,
        saveProgress: true
      }
    },
    questions: [
      {
        id: 1,
        question: "計算 \\(\\frac{3}{4} + \\frac{5}{6}\\) 的值：",
        questionEn: "Calculate the value of \\(\\frac{3}{4} + \\frac{5}{6}\\):",
        options: [
          "\\(\\frac{8}{10}\\)",
          "\\(\\frac{19}{12}\\)",
          "\\(\\frac{15}{24}\\)",
          "\\(\\frac{9}{10}\\)"
        ],
        correctAnswer: 1,
        explanation: "先通分：\\(\\frac{3}{4} + \\frac{5}{6} = \\frac{9}{12} + \\frac{10}{12} = \\frac{19}{12}\\)",
        explanationEn: "Find common denominator: \\(\\frac{3}{4} + \\frac{5}{6} = \\frac{9}{12} + \\frac{10}{12} = \\frac{19}{12}\\)",
        difficulty: "easy",
        topic: "分數運算",
        hasMath: true
      },
      {
        id: 2,
        question: "若 \\(x^2 - 5x + 6 = 0\\)，求 \\(x\\) 的值：",
        questionEn: "If \\(x^2 - 5x + 6 = 0\\), find the value of \\(x\\):",
        options: [
          "\\(x = 2\\) 或 \\(x = 3\\)",
          "\\(x = 1\\) 或 \\(x = 6\\)",
          "\\(x = -2\\) 或 \\(x = -3\\)",
          "\\(x = 5\\) 或 \\(x = 1\\)"
        ],
        correctAnswer: 0,
        explanation: "因式分解：\\(x^2 - 5x + 6 = (x-2)(x-3) = 0\\)，所以 \\(x = 2\\) 或 \\(x = 3\\)",
        explanationEn: "Factorize: \\(x^2 - 5x + 6 = (x-2)(x-3) = 0\\), so \\(x = 2\\) or \\(x = 3\\)",
        difficulty: "medium",
        topic: "二次方程",
        hasMath: true
      },
      {
        id: 3,
        question: "函數 \\(f(x) = 2x + 3\\) 的反函數是：",
        questionEn: "The inverse function of \\(f(x) = 2x + 3\\) is:",
        options: [
          "\\(f^{-1}(x) = \\frac{x-3}{2}\\)",
          "\\(f^{-1}(x) = \\frac{x+3}{2}\\)",
          "\\(f^{-1}(x) = 2x - 3\\)",
          "\\(f^{-1}(x) = \\frac{2x}{3}\\)"
        ],
        correctAnswer: 0,
        explanation: "設 \\(y = 2x + 3\\)，解出 \\(x = \\frac{y-3}{2}\\)，所以 \\(f^{-1}(x) = \\frac{x-3}{2}\\)",
        explanationEn: "Let \\(y = 2x + 3\\), solve for \\(x = \\frac{y-3}{2}\\), so \\(f^{-1}(x) = \\frac{x-3}{2}\\)",
        difficulty: "medium",
        topic: "反函數",
        hasMath: true
      }
      // Additional questions 4-30 will be added...
    ]
  },

  // Paper 2: 幾何與三角 (Geometry & Trigonometry)
  {
    id: 17,
    name: 'HKDSE Mathematics - Paper 2 (幾何與三角)',
    nameEn: 'HKDSE Mathematics - Paper 2 (Geometry & Trigonometry)',
    nameCn: 'HKDSE 数学 - 试卷2 (几何与三角)',
    nameJa: 'HKDSE 数学 - 試験2 (幾何と三角法)',
    course: '香港中學文憑考試',
    duration: 135,
    totalQuestions: 30,
    passingScore: 50,
    category: 'mathematics',
    difficulty: 'advanced',
    description: '測試幾何圖形、三角函數和空間概念知識',
    modes: {
      examMode: {
        name: '考試模式',
        description: '正式考試環境，限時完成，無提示',
        timeLimit: 135,
        showAnswers: false,
        allowReview: false,
        saveProgress: true
      },
      studyMode: {
        name: '自習模式',
        description: '學習環境，即時查看答案和解釋',
        timeLimit: null,
        showAnswers: true,
        allowReview: true,
        saveProgress: true
      },
      preTestMode: {
        name: '預測模式',
        description: '模擬考試環境，完成後顯示結果',
        timeLimit: 135,
        showAnswers: false,
        allowReview: true,
        saveProgress: true
      }
    },
    questions: [
      {
        id: 1,
        question: "在直角三角形中，若 \\(\\sin \\theta = \\frac{3}{5}\\)，求 \\(\\cos \\theta\\) 的值：",
        questionEn: "In a right triangle, if \\(\\sin \\theta = \\frac{3}{5}\\), find the value of \\(\\cos \\theta\\):",
        svgDiagram: `
          <svg width="250" height="200" viewBox="0 0 250 200">
            <polygon points="50,150 200,150 200,90" fill="none" stroke="#3b82f6" stroke-width="2"/>
            <path d="M 185 150 L 185 135 L 200 135" fill="none" stroke="#3b82f6" stroke-width="1"/>
            <text x="125" y="170" text-anchor="middle" font-size="14">鄰邊</text>
            <text x="210" y="120" text-anchor="middle" font-size="14">對邊</text>
            <text x="120" y="115" text-anchor="middle" font-size="14">斜邊</text>
            <path d="M 70 150 A 20 20 0 0 0 85 135" fill="none" stroke="#ef4444" stroke-width="2"/>
            <text x="65" y="140" font-size="12" fill="#ef4444">θ</text>
          </svg>
        `,
        options: [
          "\\(\\frac{4}{5}\\)",
          "\\(\\frac{3}{4}\\)",
          "\\(\\frac{5}{4}\\)",
          "\\(\\frac{4}{3}\\)"
        ],
        correctAnswer: 0,
        explanation: "由 \\(\\sin^2 \\theta + \\cos^2 \\theta = 1\\)，得 \\(\\cos^2 \\theta = 1 - \\left(\\frac{3}{5}\\right)^2 = 1 - \\frac{9}{25} = \\frac{16}{25}\\)，所以 \\(\\cos \\theta = \\frac{4}{5}\\)",
        explanationEn: "From \\(\\sin^2 \\theta + \\cos^2 \\theta = 1\\), we get \\(\\cos^2 \\theta = 1 - \\left(\\frac{3}{5}\\right)^2 = 1 - \\frac{9}{25} = \\frac{16}{25}\\), so \\(\\cos \\theta = \\frac{4}{5}\\)",
        difficulty: "medium",
        topic: "三角函數",
        hasMath: true,
        hasSvg: true
      },
      {
        id: 2,
        question: "在圓形中，若半徑為 \\(r = 5\\) cm，求圓周長：",
        questionEn: "In a circle with radius \\(r = 5\\) cm, find the circumference:",
        svgDiagram: `
          <svg width="200" height="200" viewBox="0 0 200 200">
            <circle cx="100" cy="100" r="60" fill="none" stroke="#3b82f6" stroke-width="3"/>
            <line x1="100" y1="100" x2="160" y2="100" stroke="#ef4444" stroke-width="2"/>
            <text x="130" y="95" font-size="14" fill="#ef4444">r = 5</text>
            <circle cx="100" cy="100" r="3" fill="#10b981"/>
            <text x="105" y="105" font-size="12">圓心</text>
          </svg>
        `,
        options: [
          "\\(10\\pi\\) cm",
          "\\(25\\pi\\) cm",
          "\\(5\\pi\\) cm",
          "\\(\\pi\\) cm"
        ],
        correctAnswer: 0,
        explanation: "圓周長公式：\\(C = 2\\pi r = 2\\pi \\times 5 = 10\\pi\\) cm",
        explanationEn: "Circumference formula: \\(C = 2\\pi r = 2\\pi \\times 5 = 10\\pi\\) cm",
        difficulty: "easy",
        topic: "圓的性質",
        hasMath: true,
        hasSvg: true
      },
      {
        id: 3,
        question: "解不等式：\\(2x + 3 > 7\\)",
        questionEn: "Solve the inequality: \\(2x + 3 > 7\\)",
        options: [
          "\\(x > 2\\)",
          "\\(x < 2\\)",
          "\\(x > 5\\)",
          "\\(x < 5\\)"
        ],
        correctAnswer: 0,
        explanation: "\\(2x + 3 > 7 \\Rightarrow 2x > 4 \\Rightarrow x > 2\\)",
        explanationEn: "\\(2x + 3 > 7 \\Rightarrow 2x > 4 \\Rightarrow x > 2\\)",
        difficulty: "easy",
        topic: "不等式",
        hasMath: true
      },
      {
        id: 4,
        question: "若 \\(\\log_2 8 = x\\)，求 \\(x\\) 的值：",
        questionEn: "If \\(\\log_2 8 = x\\), find the value of \\(x\\):",
        options: [
          "\\(3\\)",
          "\\(2\\)",
          "\\(4\\)",
          "\\(8\\)"
        ],
        correctAnswer: 0,
        explanation: "因為 \\(2^3 = 8\\)，所以 \\(\\log_2 8 = 3\\)",
        explanationEn: "Since \\(2^3 = 8\\), therefore \\(\\log_2 8 = 3\\)",
        difficulty: "medium",
        topic: "對數",
        hasMath: true
      },
      {
        id: 5,
        question: "數列 \\(2, 5, 8, 11, ...\\) 的第10項是：",
        questionEn: "The 10th term of the sequence \\(2, 5, 8, 11, ...\\) is:",
        options: [
          "\\(29\\)",
          "\\(32\\)",
          "\\(35\\)",
          "\\(26\\)"
        ],
        correctAnswer: 0,
        explanation: "這是等差數列，首項 \\(a_1 = 2\\)，公差 \\(d = 3\\)。第10項：\\(a_{10} = 2 + (10-1) \\times 3 = 2 + 27 = 29\\)",
        explanationEn: "This is an arithmetic sequence with first term \\(a_1 = 2\\) and common difference \\(d = 3\\). The 10th term: \\(a_{10} = 2 + (10-1) \\times 3 = 2 + 27 = 29\\)",
        difficulty: "medium",
        topic: "數列",
        hasMath: true
      }
      // Additional questions 6-30 will be added...
    ]
  },

  // Paper 3: 統計與概率 (Statistics & Probability)
  {
    id: 18,
    name: 'HKDSE Mathematics - Paper 3 (統計與概率)',
    nameEn: 'HKDSE Mathematics - Paper 3 (Statistics & Probability)',
    nameCn: 'HKDSE 数学 - 试卷3 (统计与概率)',
    nameJa: 'HKDSE 数学 - 試験3 (統計と確率)',
    course: '香港中學文憑考試',
    duration: 135,
    totalQuestions: 30,
    passingScore: 50,
    category: 'mathematics',
    difficulty: 'advanced',
    description: '測試統計分析、概率計算和數據處理知識',
    modes: {
      examMode: {
        name: '考試模式',
        description: '正式考試環境，限時完成，無提示',
        timeLimit: 135,
        showAnswers: false,
        allowReview: false,
        saveProgress: true
      },
      studyMode: {
        name: '自習模式',
        description: '學習環境，即時查看答案和解釋',
        timeLimit: null,
        showAnswers: true,
        allowReview: true,
        saveProgress: true
      },
      preTestMode: {
        name: '預測模式',
        description: '模擬考試環境，完成後顯示結果',
        timeLimit: 135,
        showAnswers: false,
        allowReview: true,
        saveProgress: true
      }
    },
    questions: [
      {
        id: 1,
        question: "一組數據：3, 5, 7, 9, 11 的平均數是：",
        questionEn: "The mean of the data set: 3, 5, 7, 9, 11 is:",
        options: [
          "\\(7\\)",
          "\\(6\\)",
          "\\(8\\)",
          "\\(5\\)"
        ],
        correctAnswer: 0,
        explanation: "平均數 = \\(\\frac{3 + 5 + 7 + 9 + 11}{5} = \\frac{35}{5} = 7\\)",
        explanationEn: "Mean = \\(\\frac{3 + 5 + 7 + 9 + 11}{5} = \\frac{35}{5} = 7\\)",
        difficulty: "easy",
        topic: "集中趨勢",
        hasMath: true
      }
      // Additional questions 2-30 will be added...
    ]
  }
]; 